/* eslint-disable jsx-a11y/alt-text */
import "./App.css";
import React, { Suspense, lazy, useState } from "react";
import { ConfigProvider } from "antd";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { store } from "./store";

import { Provider } from "react-redux";
import setAuthToken from "./utils/setAuthToken";
import AdminRoute from "./routes/AdminRoute";
import Sidebar from "./layout/Sidebar";
import Navbar from "./layout/Navbar";
import { saveConfig, setAdmin } from "./actions/AuthAction";
import { setConfig } from "./reducers/configReducer";

import { isPermitted } from "./utils/PermissionManager";
import { setProfile } from "./reducers/authReducer";
import Bottombar from "./layout/BottomBar";
import LoginFailed from "./pages/LoginFailed";


const Ideas = lazy(() => import("./pages/Ideas"));
const OfficeComplains = lazy(() => import("./pages/OfficeComplains"));

const ReadyRefundNew = lazy(() => import("./pages/ReadyRefundNew"));
const SlowOrders = lazy(() => import("./pages/SlowOrders"));
const RmbTransactionReport = lazy(() => import("./pages/RmbTransactionReport"));
const RmbTransactionDetails = lazy(() => import("./pages/RmbTranscationDetails"));

const ApprovalCenter = lazy(() => import("./pages/ApprovalCenter"));
const PurchasingV4 = lazy(() => import("./pages/PurchasingV4"));
const ManualPurchaseV4 = lazy(() => import("./pages/ManualPurchaseV4"));
const RepurchaseV4 = lazy(() => import("./pages/RepurchaseV4"));
const PurchaseCompletedV4 = lazy(() => import("./pages/PurchaseCompletedV4"));
const ConfirmationCenterV4 = lazy(() => import("./pages/ConfirmationCenterV4"));
const PurchaseCenter = lazy(() => import("./pages/PurchaseCenter"));
const SupplierResponse = lazy(() => import("./pages/SupplierResponse"));

const Sorting = lazy(() => import("./pages/Sorting"));
const VerifiedPurchase = lazy(() => import("./pages/VerifiedPurchase"));
const ReadySheets = lazy(() => import("./pages/ReadySheets"));
const WaitingOrders = lazy(() => import("./pages/WaitingOrders"));
const ManualPurchase = lazy(() => import("./pages/ManualPurchase"));
const PendingOrderPurchase = lazy(() => import("./pages/PendingOrderPurchase"));

const Gallery = lazy(() => import("./pages/Gallery"));
const GalleryFolder = lazy(() => import("./pages/GalleryFolder"));

const ExportCustomer = lazy(() => import("./pages/ExportCustomer"));
const DisasterOrders = lazy(() => import("./pages/DisasterOrders"));

const RiskyHub = lazy(() => import("./pages/RiskyHub"));
const DeliveryPaymentReport = lazy(
  () => import("./pages/DeliveryPaymentReport"),
);
const SkyOnePurchase = lazy(() => import("./pages/SkyOnePurchase"));
const SetShippingCharge = lazy(() => import("./pages/SetShippingCharge"));
const BulkOrderCartonList = lazy(() => import("./pages/BulkOrderCartonList"));
const ShippingCategories = lazy(() => import("./pages/ShippingCategories"));
const ShippingCharges = lazy(() => import("./pages/ShippingCharges"));
const ShippingCategory = lazy(() => import("./pages/ShippingCategory"));

const AutoPayment = lazy(() => import("./pages/AutoPayment"));
const SeaOrderConfirm = lazy(() => import("./pages/SeaOrderConfirm"));

const CustomerConfirmation = lazy(() => import("./pages/CustomerConfirmation"));
const PurchasePaymentConfirmation = lazy(
  () => import("./pages/PurchasePaymentConfirmation"),
);
const AutoPurchaseVerification = lazy(
  () => import("./pages/AutoPurchaseVerification"),
);
const LogisticConfirmation = lazy(() => import("./pages/LogisticConfirmation"));
const PurchaseConfirmation = lazy(() => import("./pages/PurchaseConfirmation"));
const SeaPurchase = lazy(() => import("./pages/SeaPurchase"));
const AirPurchase = lazy(() => import("./pages/AirPurchase"));

const AutoTracking = lazy(() => import("./pages/AutoTracking"));
const AutoPurchase = lazy(() => import("./pages/AutoPurchase"));
const Purchase = lazy(() => import("./pages/Purchase"));
const SeaPurchasing = lazy(() => import("./pages/SeaPurchasing"));
const QcCustomer = lazy(() => import("./pages/QcCustomer"));
const BalanceHub = lazy(() => import("./pages/BalanceHub"));
const B2CRecharge = lazy(() => import("./pages/B2CRecharge"));
const CRMCustomer = lazy(() => import("./pages/crm/CRMCustomer"));

const QcAcknowledgement = lazy(() => import("./pages/QcAcknowledgement"));

const RefundHistory = lazy(() => import("./pages/RefundHistory"));

const ReadyRefunds = lazy(() => import("./pages/ReadyRefund"));

const RefundHub = lazy(() => import("./pages/RefundHub"));

const PurchaseVerification = lazy(() => import("./pages/PurchaseVerification"));
const PurchasePayment = lazy(() => import("./pages/PurchasePayment"));

const IncompletePurchase = lazy(() => import("./pages/IncompletePurchase"));
const Agents = lazy(() => import("./pages/Agents"));
const AgentOrders = lazy(() => import("./pages/AgentOrders"));
const AgentWithdraw = lazy(() => import("./pages/AgentWithdraws"));
const AgentWithdrawPay = lazy(() => import("./pages/AgentWithdrawPay"));

const Campaign = lazy(() => import("./pages/Campaign"));
const ManageTicket = lazy(() => import("./pages/ManageTicket"));

const Calls = lazy(() => import("./pages/Calls"));
const Support = lazy(() => import("./pages/Support"));

const Campaigns = lazy(() => import("./pages/Campaigns"));
const CartonOrders = lazy(() => import("./pages/CartonOrders"));
const RateSettings = lazy(() => import("./pages/RateSettings"));
const ChargeSetting = lazy(() => import("./pages/ChargeSettings"));
const BecommerceSetting = lazy(() => import("./pages/BecommerceSetting"));

const Invoice = lazy(() => import("./pages/Invoice"));
const CashCounter = lazy(() => import("./pages/CashCounter"));

const Coupon = lazy(() => import("./pages/Coupons"));
const DeliveryComplete = lazy(() => import("./pages/DeliveryComplete"));

const Tracking = lazy(() => import("./pages/Tracking"));
const ShipmentDetails = lazy(() => import("./pages/ShipmentDetails"));

const Customers = lazy(() => import("./pages/Customers"));
const Login = lazy(() => import("./pages/Login"));
const Orders = lazy(() => import("./pages/Orders"));
const ManageOrder = lazy(() => import("./pages/ManageOrder"));
const Admins = lazy(() => import("./pages/Admins"));
const Payments = lazy(() => import("./pages/Payments"));
const Profile = lazy(() => import("./pages/Profile"));
const ComingSoon = lazy(() => import("./pages/ComingSoon"));
const Purchasing = lazy(() => import("./pages/Purchasing"));

if (localStorage.config) {
  let config = JSON.parse(localStorage.config);
  let profile = config.profile;
  store.dispatch(setProfile(profile));
  store.dispatch(setConfig(config));
}

if (localStorage.skyadmin) {
  setAuthToken(localStorage.skyadmin);
  store.dispatch(setAdmin(true));
  store.dispatch(saveConfig());
}

const DashboardNew = lazy(() => import("./pages/DashboardNew"));
const BulkNotification = lazy(() => import("./pages/BulkNotification"));
const Tasks = lazy(() => import("./pages/Tasks"));
const ChatChina = lazy(() => import("./pages/ChatChina"));
const ManageTask = lazy(() => import("./pages/ManageTask"));
const Complains = lazy(() => import("./pages/Complains"));
const Suppliers = lazy(() => import("./pages/marketplace/Suppliers"));
const Stores = lazy(() => import("./pages/marketplace/Stores"));
const Categories = lazy(() => import("./pages/marketplace/Categories"));
const Products = lazy(() => import("./pages/marketplace/Products"));
const ManageProduct = lazy(() => import("./pages/marketplace/ManageProduct"));

function App() {
  const client = window.screen.width > 768 ? "web" : "app";
  const [show, setshow] = useState(client === "web" ? false : true);
  const [trigger, settrigger] = useState(false);

  const id = store.getState().auth?.profile?._id;

  const host = window.location.host;

  let search = window.location.search;
  let params = new URLSearchParams(search);
  let accessKey = params.get("ak");

  if (accessKey) {
    let lastTimeToAccess = accessKey;
    if (lastTimeToAccess) {
      localStorage.setItem("skyadmin", lastTimeToAccess);
      setAuthToken(lastTimeToAccess);
      store.dispatch(setAdmin(true));
      store.dispatch(saveConfig());
      setTimeout(() => {
        window.location.href = "/";
      }, 1000);
    }
  }

  if (host !== "shahil.skybuybd.com" && host !== "localhost:3000") {
    return (
      <div
        className="flex align-center justify-center flexColumn"
        style={{ height: "100vh", width: "100%", background: "#fff" }}
      >
        <img src={require("./assets/locked.png")} style={{ width: 220 }} />
        <h2 className="mt1">Site Locked</h2>
        <p>This website is locked please contact authorized person.</p>
      </div>
    );
  }

  const roles = store.getState().auth?.profile?.roles
    ? store.getState().auth?.profile?.roles
    : [];

  return (
    <Provider store={store}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#167389",
          },
        }}
      >
        <BrowserRouter>
          <Suspense fallback={<div className="pageProgress"></div>}>
            <div className="App">
              <Sidebar state={{ show, setshow }} />
              <div>
                <Navbar state={{ settrigger, setshow, show }} />
                {roles?.length > 0 && <Bottombar />}
                <Routes>
                  <Route
                    exact
                    path="/"
                    element={
                      <AdminRoute
                        state={{ show, trigger }}
                        component={<DashboardNew />}
                      />
                    }
                  />

                  {isPermitted(roles, ["super_admin"]) && (
                    <Route
                      exact
                      path="/customers"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<Customers />}
                        />
                      }
                    />
                  )}

                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                    "china_basic",
                    "china_crm",
                    "china_purchase",
                    "china_admin",
                    "order",
                  ]) && (
                      <Route
                        exact
                        path="/orders"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<Orders />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                    "china_basic",
                    "china_crm",
                    "china_purchase",
                    "china_admin",
                    "order",
                    'china',
                    'crm'
                  ]) && <Route
                      exact
                      path="/order/:id"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<ManageOrder />}
                        />
                      }
                    />}
                  {isPermitted(roles, ["super_admin"]) && (
                    <Route
                      exact
                      path="/airport-damaged"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<DisasterOrders />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                      <Route
                        exact
                        path="/purchase/:id"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<Purchase />}
                          />
                        }
                      />
                    )}
                  <Route
                    exact
                    path="/campaign/:id"
                    element={
                      <AdminRoute
                        state={{ show, trigger }}
                        component={<Campaign />}
                      />
                    }
                  />


                  {isPermitted(roles, ["super_admin", "accountant"]) && (
                    <Route
                      exact
                      path="/rmb-transaction-report"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<RmbTransactionReport />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["super_admin", "accountant"]) && (
                    <Route
                      exact
                      path="/rmb-transaction-details/:id"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<RmbTransactionDetails />}
                        />
                      }
                    />
                  )}

                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                    "china_basic",
                    "china_crm",
                    "china_purchase",
                    "china_admin",
                    "order",
                    'china'
                  ]) && <Route
                      exact
                      path="/cartons/:id"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<CartonOrders />}
                        />
                      }
                    />}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                    "china_basic",
                    "china_crm",
                    "china_purchase",
                    "china_admin",
                    "order",
                    'china'
                  ]) && <Route
                      exact
                      path="/bulk-order-carton-list/:id"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<BulkOrderCartonList />}
                        />
                      }
                    />}
                  {isPermitted(roles, [
                    "super_admin",
                    "admin",
                    "support",
                    "china_admin",
                    "china_crm",
                  ]) && (
                      <Route
                        exact
                        path="/support/:id"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<ManageTicket />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                    "crm",
                    "china_basic",
                    "china_crm",
                    "china_purchase",
                    "china_admin",
                    "order",
                    'china_purchase',
                    'china_admin',
                    'china'
                  ]) && <Route
                      exact
                      path="/calls"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<Calls />}
                        />
                      }
                    />}
                  {isPermitted(roles, ["admin", "shipment"]) && (
                    <Route
                      exact
                      path="/shipment/:id"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<ShipmentDetails />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["admin", "shipment"]) && (
                    <Route
                      exact
                      path="/set-shipping-charge/:id"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<SetShippingCharge />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["admin", "marketing"]) && (
                    <Route
                      exact
                      path="/gallery"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<Gallery />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["admin", "marketing"]) && (
                    <Route
                      exact
                      path="/gallery/:id"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<GalleryFolder />}
                        />
                      }
                    />
                  )}

                  {isPermitted(roles, ["admin", "marketing"]) && (
                    <Route
                      exact
                      path="/bulk-notification"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<BulkNotification />}
                        />
                      }
                    />
                  )}

                  {isPermitted(roles, ["super_admin"]) && (
                    <Route
                      exact
                      path="/shipping-category"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<ShippingCategory />}
                        />
                      }
                    />
                  )}

                  {isPermitted(roles, ["super_admin"]) && (
                    <Route
                      exact
                      path="/tasks"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<Tasks />}
                        />
                      }
                    />
                  )}

                  {isPermitted(roles, ["super_admin"]) && (
                    <Route
                      exact
                      path="/tasks/:id"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<ManageTask />}
                        />
                      }
                    />
                  )}

                  {isPermitted(roles, ["admin"]) && (
                    <Route
                      exact
                      path="/agents"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<Agents />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["admin"]) && (
                    <Route
                      exact
                      path="/agent/orders"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<AgentOrders />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["admin"]) && (
                    <Route
                      exact
                      path="/agent/withdraws"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<AgentWithdraw />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["admin"]) && (
                    <Route
                      exact
                      path="/agent/withdraw/:id"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<AgentWithdrawPay />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["admin"]) && (
                    <Route
                      exact
                      path="/invoice/:id"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<Invoice />}
                        />
                      }
                    />
                  )}

                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                      <Route
                        exact
                        path="/pending-orders"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<PendingOrderPurchase />}
                          />
                        }
                      />
                    )}

                  {isPermitted(roles, ["super_admin", "china_admin"]) && (
                    <Route
                      exact
                      path="/v4/purchase-approval-center"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<ApprovalCenter />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["super_admin"]) && (
                    <Route
                      exact
                      path="/v4/confirmation-center"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<ConfirmationCenterV4 />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["master_admin"]) && (
                    <Route
                      exact
                      path="/ideas"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<Ideas />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["master_admin"]) && (
                    <Route
                      exact
                      path="/office-complains"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<OfficeComplains />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                    "china_admin",
                  ]) && (
                      <Route
                        exact
                        path="/v4/purchasing"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<PurchasingV4 />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                      <Route
                        exact
                        path="/approved-orders"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<VerifiedPurchase />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                      <Route
                        exact
                        path="/manual-purchase"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<ManualPurchase />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                      <Route
                        exact
                        path="/v4/manual-purchase"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<ManualPurchaseV4 />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                      <Route
                        exact
                        path="/v4/repurchase"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<RepurchaseV4 />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                      <Route
                        exact
                        path="/v4/purchase-completed"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<PurchaseCompletedV4 />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                    "china_purchase",
                    "china_admin",
                  ]) && (
                      <Route
                        exact
                        path="/v4/purchase-center"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<PurchaseCenter />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "china_purchase",
                    "china_admin",
                  ]) && (
                      <Route
                        exact
                        path="/v4/supplier-response"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<SupplierResponse />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "china_admin",
                    "china_crm",
                  ]) && (
                      <Route
                        exact
                        path="/china-crm/purchase-center"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<PurchaseCenter />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "china_admin",
                    "china_crm",
                  ]) && (
                      <Route
                        exact
                        path="/china-crm/slow-orders"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<SlowOrders />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "china_admin",
                    "china_crm",
                  ]) && (
                      <Route
                        exact
                        path="/china-crm/supplier-response"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<SupplierResponse />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "china_admin",
                    "china_crm",
                  ]) && (
                      <Route
                        exact
                        path="/china-crm/qc"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<QcAcknowledgement chinaQc={true} />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "china_admin",
                    "china_crm",
                  ]) && (
                      <Route
                        exact
                        path="/china-crm/qc-customer"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<QcCustomer chinaQc={true} />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "china_admin",
                    "china_crm",
                  ]) && (
                      <Route
                        exact
                        path="/china-crm/skyone-purchase"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<SkyOnePurchase chinaQc={true} />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "china_crm",
                    "china_admin",
                  ]) && (
                      <Route
                        exact
                        path="/china-crm/support"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<Support chinaCrm={true} />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "china_crm",
                    "china_admin",
                  ]) && (
                      <Route
                        exact
                        path="/china-crm/chat/:order?"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<ChatChina chinaCrm={true} />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                      <Route
                        exact
                        path="/waiting-orders"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<WaitingOrders />}
                          />
                        }
                      />
                    )}

                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                      <Route
                        exact
                        path="/ready-sheets"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<ReadySheets />}
                          />
                        }
                      />
                    )}

                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                      <Route
                        exact
                        path="/qc"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<QcAcknowledgement />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                    "china_admin",
                  ]) && (
                      <Route
                        exact
                        path="/qc-customer"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<QcCustomer />}
                          />
                        }
                      />
                    )}

                  {isPermitted(roles, ["admin"]) && (
                    <Route
                      exact
                      path="/sea-orders"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<SeaOrderConfirm />}
                        />
                      }
                    />
                  )}

                  {isPermitted(roles, ["super_admin"]) && (
                    <Route
                      exact
                      path="/settings/rates"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<RateSettings />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["super_admin"]) && (
                    <Route
                      exact
                      path="/settings/shipping-charges"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<ChargeSetting />}
                        />
                      }
                    />
                  )}
                  {[
                    "646b312b4bf0ab131ff44e9a",
                    "644904810578558b71b8e622",
                  ].includes(id) &&
                    isPermitted(roles, ["admin"]) && (
                      <Route
                        exact
                        path="/settings/becommerce"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<BecommerceSetting />}
                          />
                        }
                      />
                    )}

                  {isPermitted(roles, ["super_admin", "accountant"]) && (
                    <Route
                      exact
                      path="/cash-counter/:id?"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<CashCounter />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["super_admin", "accountant"]) && (
                    <Route
                      exact
                      path="/point"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<BalanceHub />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["master_admin", "super_admin"]) && (
                    <Route
                      exact
                      path="/b2c-recharge"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<B2CRecharge />}
                        />
                      }
                    />
                  )}

                  {isPermitted(roles, ["admin"]) && (
                    <Route
                      exact
                      path="/crm/customer/:id"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<CRMCustomer />}
                        />
                      }
                    />
                  )}

                  {isPermitted(roles, ["admin", "shipment"]) && (
                    <Route
                      exact
                      path="/shipping-categories"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<ShippingCategories />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["admin", "shipment"]) && (
                    <Route
                      exact
                      path="/shipping-charges"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<ShippingCharges />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, [
                    "admin",
                    "cn_purchase",
                    "bn_purchase",
                  ]) && (
                      <Route
                        exact
                        path="/risky"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<RiskyHub />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, ["admin"]) && (
                    <Route
                      exact
                      path="/delivery/:id"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<DeliveryComplete />}
                        />
                      }
                    />
                  )}

                  {isPermitted(roles, [
                    "super_admin",
                    "admin",
                    "accountant",
                  ]) && (
                      <Route
                        exact
                        path="/delivery-payment-report"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<DeliveryPaymentReport />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, ["super_admin", "accountant"]) && (
                    <Route
                      exact
                      path="/pending-refunds"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<RefundHub />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["super_admin", "accountant"]) && (
                    <Route
                      exact
                      path="/refund-history"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<RefundHistory />}
                        />
                      }
                    />
                  )}
                  {/* {isPermitted(roles, ["super_admin", "admin"]) && (
                    <Route
                      exact
                      path="/refund-report"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<RefundReport />}
                        />
                      }
                    />
                  )} */}
                  {isPermitted(roles, ["super_admin", "accountant"]) && (
                    <Route
                      exact
                      path="/ready-refunds"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<ReadyRefunds />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["super_admin", "accountant"]) && (
                    <Route
                      exact
                      path="/ready-refunds-new"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<ReadyRefundNew />}
                        />
                      }
                    />
                  )}

                  {isPermitted(roles, ["admin", "support", "china_admin"]) && (
                    <Route
                      exact
                      path="/support"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<Support />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["admin", "support", "china_admin"]) && (
                    <Route
                      exact
                      path="/complains"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<Complains />}
                        />
                      }
                    />
                  )}

                  {isPermitted(roles, ["super_admin"]) && (
                    <Route
                      exact
                      path="/coupons"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<Coupon />}
                        />
                      }
                    />
                  )}

                  {isPermitted(roles, ["super_admin", "marketplace"]) && (
                    <Route
                      exact
                      path="/marketplace/suppliers"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<Suppliers />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["super_admin", "marketplace"]) && (
                    <Route
                      exact
                      path="/marketplace/stores"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<Stores />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["super_admin", "marketplace"]) && (
                    <Route
                      exact
                      path="/marketplace/categories"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<Categories />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["super_admin", "marketplace"]) && (
                    <Route
                      exact
                      path="/marketplace/products"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<Products />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["super_admin", "marketplace"]) && (
                    <Route
                      exact
                      path="/marketplace/manage-product"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<ManageProduct />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["super_admin", "marketplace"]) && (
                    <Route
                      exact
                      path="/marketplace/manage-product/:id"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<ManageProduct />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["master_admin"]) && (
                    <Route
                      exact
                      path="/export-customer-arzxxxxxx"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<ExportCustomer />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["super_admin"]) && (
                    <Route
                      exact
                      path="/campaigns"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<Campaigns />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                      <Route
                        exact
                        path="/sorting"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<Sorting />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, ["super_admin"]) && (
                    <Route
                      exact
                      path="/admins"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<Admins />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                      <Route
                        exact
                        path="/air-purchase"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<Purchasing />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                    "china_purchase",
                    "china_admin",
                  ]) && (
                      <Route
                        exact
                        path="/skyone-purchase"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<SkyOnePurchase />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                      <Route
                        exact
                        path="/air-purchase-new"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<AirPurchase />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                      <Route
                        exact
                        path="/sea-purchase-new"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<SeaPurchase />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "cn_purchase",
                    "china_purchase",
                    "china_admin",
                  ]) && (
                      <Route
                        exact
                        path="/supplier-confirmation"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<PurchaseConfirmation />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                      <Route
                        exact
                        path="/customer-confirmation"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<CustomerConfirmation />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                      <Route
                        exact
                        path="/logistic-confirmation"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<LogisticConfirmation />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, ["admin", "china_admin"]) && (
                    <Route
                      exact
                      path="/purchase-payment-confirmation"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<PurchasePaymentConfirmation />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["admin", "china_admin"]) && (
                    <Route
                      exact
                      path="/auto-purchase-verification"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<AutoPurchaseVerification />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["admin", "china_admin"]) && (
                    <Route
                      exact
                      path="/auto-payment"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<AutoPayment />}
                        />
                      }
                    />
                  )}

                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                      <Route
                        exact
                        path="/sea-purchase"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<SeaPurchasing />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                      <Route
                        exact
                        path="/incomplete-purchase"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<IncompletePurchase />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                      <Route
                        exact
                        path="/purchase-verification"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<PurchaseVerification />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                      <Route
                        exact
                        path="/purchase-payment"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<PurchasePayment />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                    "china_admin",
                  ]) && (
                      <Route
                        exact
                        path="/tracking"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<Tracking />}
                          />
                        }
                      />
                    )}
                  {isPermitted(roles, ["admin", "tracking", "china_admin"]) && (
                    <Route
                      exact
                      path="/auto-tracking"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<AutoTracking />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["admin"]) && (
                    <Route
                      exact
                      path="/auto-purchase"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<AutoPurchase />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["super_admin", "accountant"]) && (
                    <Route
                      exact
                      path="/payments"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<Payments />}
                        />
                      }
                    />
                  )}

                  <Route
                    exact
                    path="/profile"
                    element={
                      <AdminRoute
                        state={{ show, trigger }}
                        component={<Profile />}
                      />
                    }
                  />

                  <Route
                    exact
                    path="/chat/:order?"
                    element={
                      <AdminRoute
                        state={{ show, trigger }}
                        component={<ChatChina />}
                      />
                    }
                  />

                  <Route exact path="/login" element={<Login />} />
                  <Route exact path="/unauthorized" element={<LoginFailed />} />

                  <Route
                    path="*"
                    element={
                      <AdminRoute
                        state={{ show, trigger }}
                        component={
                          <div
                            style={{
                              height: "calc(100vh - 78px)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#fff",
                            }}
                          >
                            <ComingSoon />
                          </div>
                        }
                      />
                    }
                  />
                </Routes>
              </div>
            </div>
          </Suspense>
        </BrowserRouter>
      </ConfigProvider>
    </Provider>
  );
}

export default App;
